<template>
	<view class="box">
		<view class="box_ipt">
			<uni-search-bar radius="100" placeholder="搜你想看的" bgColor="#EEEEEE" />
		</view>
		<view class="box_history">
			<view class="title">
				<text>历史搜索</text>
				<image src="@/static/icon/search_ic_clean@2x.png" mode="widthFix"></image>
			</view>
			<view class="list">
				<view class="list_item">麦隆咖啡</view>
				<view class="list_item">麦隆咖啡</view>
			</view>
		</view>
		<view class="box_list">
			<shopitem />
			<shopitem />
			<shopitem />
		</view>
	</view>
</template>

<script>
	import shopitem from '@/components/ShopItem/index.vue'
	export default {
		data() {
			return {
				
			}
		},
		components: { shopitem }
	}
</script>

<style>
	page {
		background-color: #ffffff !important;
	}
</style>

<style lang="scss" scoped>
	.box {
		width: 100%;
		padding: 32rpx;
		box-sizing: border-box;
		.box_ipt /deep/ {
			width: 100%;
			.uni-searchbar__box {
				justify-content: flex-start;
			}
			.uni-searchbar {
				padding: 0;
			}
		}
		.box_history {
			width: 100%;
			margin-top: 40rpx;
			display: flex;
			flex-direction: column;
			.title {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-bottom: 28rpx;
				text {
					font-size: 32rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #333333;
				}
				image {
					width: 40rpx;
					height: 40rpx;
				}
			}
			.list {
				width: 100%;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				.list_item {
					padding: 10rpx 28rpx;
					background: #F5F5F5;
					border-radius: 24rpx;
					font-size: 28rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #333333;
					margin-left: 16rpx;
					&:first-child {
						margin-left: 0;
					}
				}
			}
		}
		.box_list {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex-wrap: wrap;
			margin-top: 40rpx;
		}
	}
</style>